module.exports = __webpack_public_path__ + "media/images/pages/img_digest_restaurant_02-7e4a43fc6eaf62a8e9387de4e660f8d4.jpg";